<template>
  <span class="text-nowrap">
    <b-badge :variant="`light-${statusVariant(game)}`">{{ statusLabel(game) }}</b-badge>
    <b-badge v-if="game && game.source === 'planfix'" variant="light-info" class="ml-25">вне плана</b-badge>
    <b-badge v-if="game && game.is_rescheduled" variant="light-warning" class="ml-25" title="Время в Planfix отличается от плана">перенос</b-badge>
    <b-badge v-if="game && game.is_host_changed" variant="light-warning" class="ml-25" title="Ведущий в Planfix отличается от плана">замена</b-badge>
  </span>
</template>

<script>
import { BBadge } from 'bootstrap-vue'
import { statusVariant, statusLabel } from '@/views/game/planFact'

export default {
  components: { BBadge },
  props: {
    game: { type: Object, default: null },
  },
  setup() {
    return { statusVariant, statusLabel }
  },
}
</script>
